import "leaflet/dist/leaflet.css";
import Vue from "vue";
import "../../main.js";
import "../theme/js/main.js";
import auth, { handleAuth } from "./boot/auth";
import initRouter from "./boot/initRouter";
import initStore from "./boot/store/initStore";
import initLocalforage from "./boot/localforage/initLocalforage";
import App from "./components/AppComponent";
import "./boot/directives";
import "./boot/filters";
import initComponents from "./boot/components";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueClipboard from "vue-clipboard2";
import VueSnackbar from "vue-snack";
import "vue-snack/dist/vue-snack.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import * as Replay from "@sentry/replay";

Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.use(VueSnackbar, { position: "bottom", time: 3000 });

Vue.prototype.i18n = i18n;
Vue.prototype.config = config;

if (localStorage.getItem("locale")) {
  axios.defaults.headers.common["X-Locale"] = localStorage.getItem("locale");
}

initComponents(config.google.api_key_frontend);

const store = initStore(auth);
const router = initRouter(store);
initLocalforage();

Sentry.init({
  App,
  dsn: process.env.MIX_SENTRY_VUE_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // Unactionable host/WebView bridge errors (CefSharp / Outlook Safe Links), not app code.
  ignoreErrors: [
    /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/,
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", config.app.api_url],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export default new Vue({
  store,
  el: "#app",
  router: router,
  mounted() {
    handleAuth(store).catch(e => {
      this.$router.push({ name: "login" });
    });
  },
  render: h => h(App)
});
